/**
 * Decodes HTML entities in a string by leveraging the browser's HTML parser.
 *
 * @param html - A string that may contain HTML entities (e.g. `&amp;`, `&lt;`)
 * @returns The decoded plain-text string
 */
export function decodeHtml(html: string): string {
    html = html.replace(/&amp;/g, "&");

    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
}
